/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc, SCS, debug) {
	'use strict';

	// allocate one container at the body level
	// avoids beeing inside any overflow hidden node
	var bodyContainer;

	/**
	 * JQuery Autocomplete Wrapper
	 * http://api.jqueryui.com/autocomplete/
	 *
	 * @author Marc Althoff
	 * @namespace Tc.Module
	 * @class Autocomplete
	 * @extends Tc.Module
	 */
	Tc.Module.Autocomplete = Tc.Module.extend({

		// cached directly via varnish
		url: '/portalshop-api/res/product/getexportproductsbycategorynew/RES_MO_PHONES',
		data: [],

		/**
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var
				mod = this;

			mod.getData();

			callback();
		},

		getData: function () {
			var
				mod = this;

			$.ajax({
				url: mod.url,
				dataType: "json",
				success: function (json) {
					mod.parseData(json);
				},
				error: function () {
					debug.log('Tc.Module.Autocomplete.js / error: ajax call to ' + mod.url + 'failed');
				},
				statusCode: {
					404: function () {
						debug.log('Tc.Module.Autocomplete.js / statusCode.404: URL not found');
					},
					500: function () {
						debug.log('Tc.Module.Autocomplete.js / statusCode.500: Service not available');
					},
					503: function () {
						debug.log('Tc.Module.Autocomplete.js / statusCode.503: Service Temporarily Unavailable');
					}
				}
			});
		},

		parseData: function (data) {

			var
				mod = this,
				type = mod.$ctx.attr("data-autocomplete");

			function unique(array) {
				return $.grep(array, function (el, index) {
					return index == $.inArray(el, array);
				});
			}

			function parseManufacturers(data) {
				var brands = Array();
				data['ExportProductList'].forEach(function (product) {
					brands.push(product['ProductBrand']);
				});
				return unique(brands);
			}

			function parseDevices(data, language) {
				var products = Array();
				data['ExportProductList'].forEach(function (product) {
					product['Names'].forEach(function (name) {
						if (name['Language'].substr(0, 2) == language) {
							products.push(name['Name']);
						}
					});
				});
				var productList = unique(products);
				return productList.sort();
			}

			if (type === 'manufacturer') {
				mod.data = parseManufacturers(data);
			} else if (type === 'device') {
				mod.data = $.unique(parseDevices(data, ($('html').attr('lang') || "de")));
			}
			mod.populateFields();

		},

		populateFields: function () {
			var
				mod = this;

			// create body container only once
			if (!bodyContainer) {
				bodyContainer = jQuery('<DIV>')
					.addClass('autocompleteMenuTarget')
					.appendTo('BODY');
			}

			$('.autocomplete', mod.$ctx).autocomplete({
				source: mod.data,
				minLength: (mod.$ctx.attr('data-minlength') || 2),
				appendTo: bodyContainer
			});
		}
	});

}(window.Tc.$, window.Tc, window.SCS = window.SCS || {}, window.debug));




}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.Autocomplete.js
// module id = 267
// module chunks = 0